import {Component, OnInit, Input, Output, EventEmitter, Renderer2, ViewChild, ElementRef, HostListener} from '@angular/core';
import {TasksModel} from '../../../tasks/models/tasks.model';
import {TasksService} from '../../../tasks/tasks.service';
import {DomSanitizer} from '@angular/platform-browser';
import {Subscription} from 'rxjs';
import {EventsService} from '../../../../services/events.service';
import {NavService} from '../../../../services/nav.service';
import {NgClass, NgIf, NgStyle} from '@angular/common';
import {CardButtonComponent} from '../card-button/card-button.component';
import {PipesModule} from '../../../../pipes/pipes.module';
import {InteractionCardDto} from '../../models/card.model';

@Component({
  selector: 'app-card-video',
  templateUrl: './card-video.component.html',
  styleUrls: ['./card-video.component.scss'],
  standalone: true,
  imports: [NgStyle, NgClass, NgIf, CardButtonComponent, PipesModule],
})
export class CardVideoComponent implements OnInit {

  subscriptions: Subscription[] = [];

  url: string = null;
  description: string = null;
  isVideo = false;
  isImage = false;
  isYoutube = false;
  isVimeo = false;
  isMeetingPulse = false;
  isSIM = false;
  isHyperbound = false;
  simSrc = null;
  videoId = null;
  task: TasksModel = null;

  resizeTimeout: any;
  videoWidth = 640;
  videoHeight = 330;

  @ViewChild('youtubeContainer') youtubeContainer!: ElementRef;
  private player: any;

  doPlayEmitted = false;
  @Output() doPlay: EventEmitter<any> = new EventEmitter();
  @Output() onPlayFinished = new EventEmitter<boolean>();

  @Input() disabled = false;

  @Input() set card(card: InteractionCardDto) {
    this.videoId = null;
    this.url = null;

    this._card = card;
    this.isSubmitted = (card.cardAnswer && card.cardAnswer.isCompleted);

    setTimeout(() => {
      this.initData();
    }, 0);
  }

  isSubmitted: boolean = false;
  _card: InteractionCardDto;

  initData() {
    this.videoId = 'video_' + this._card.id;
    this.setUrl(this._card.url1);
  }

  setUrl(url: string) {
    this.url = url;
    this.isYoutube = this.url.includes('youtube') || this.url.includes('youtu.be');
    this.isVimeo = this.url.includes('vimeo');
    this.isMeetingPulse = this.url.includes('meet.ps');
    this.isSIM = this.url.includes('speakeasy-client');
    this.isHyperbound = this.url.includes('hyperbound.ai');
    this.isImage = this.url.includes('.png') || this.url.includes('.jpg') || this.url.includes('.jpeg') || this.url.includes('.gif');
    this.isVideo = this.url && !this.isVimeo && !this.isYoutube && !this.isMeetingPulse && !this.isSIM && !this.isHyperbound && !this.isImage;

    if (this.isYoutube) {
      const rx = /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/|shorts\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/;
      const r = this.url.match(rx);
      if (r.length > 0) {
        this.videoId = r[1];
        console.log('VideoID', this.videoId);
      } else {
        this.isYoutube = false;
      }
    }

    if (this.isSIM) {
      this.loadIframe();
    }

    if (this.isYoutube) {
      this.loadYoutubeApi();

      if (!window['YT'] && !window['onYouTubeIframeAPIReady']) {
        window['onYouTubeIframeAPIReady'] = () => {
          this.event.publish('onYouTubeIframeAPIReady');
        };
      } else {
        this.createYoutubePlayer();
      }
    }

    if (this.isVideo) {
      setTimeout(() => {
        const video = document.getElementById(this.videoId) as HTMLMediaElement;
        console.log('Video', video);
        video.addEventListener('ended', (event) => {
          console.log(event);
          this.onPlayFinished.emit(true);
        }, {once: true});
      }, 0);
    }
  }

  @HostListener('window:resize', ['$event'])
  sizeChange(event) {
    if (this.isYoutube) {
      clearTimeout(this.resizeTimeout);
      this.resizeYoutubePlayer();
    }
  }

  constructor(
    private componentContainer: ElementRef,
    private tasksService: TasksService,
    public sanitizer: DomSanitizer,
    private event: EventsService,
    private renderer: Renderer2
  ) {
    this.subscriptions.push(
      this.event.subscribe('onYouTubeIframeAPIReady', () => {
        if (this.isYoutube) {
          this.createYoutubePlayer();
        }
      })
    );
  }

  ngOnInit() {
  }

  loadYoutubeApi() {
    if (!window['YT'] && !window['YTLoading']) {
      window['YTLoading'] = true;
      const tag = this.renderer.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      this.renderer.appendChild(document.body, tag);
    }
  }

  createYoutubePlayer() {
    if (window['YT'] && !this.player && this.isYoutube && this.videoId) {
      this.player = new window['YT'].Player(this.youtubeContainer.nativeElement, {
        videoId: this.videoId,
        playerVars: {
          credentialless: true,
        },
        events: {
          'onReady': this.onPlayerReady.bind(this),
          'onStateChange': this.onPlayerStateChange.bind(this),
        },
      });
    }
  }

  resizeYoutubePlayer() {
    this.resizeTimeout = setTimeout(() => {
      if (this.player) {
        const ratio = this.videoHeight / this.videoWidth;
        this.player.setSize(
          this.componentContainer.nativeElement.offsetWidth,
          this.componentContainer.nativeElement.offsetWidth * ratio);

      }
    }, 20);
  }

  onPlayerReady(event: any) {
    this.videoWidth = event.target.playerInfo.size.width || 640;
    this.videoHeight = event.target.playerInfo.size.height || 330;
    this.resizeYoutubePlayer();
  }

  onPlayerStateChange(event: any) {
    if (!this.task.click && event.data == window['YT'].PlayerState.PLAYING && !this.doPlayEmitted) {
      this.doPlayEmitted = true;
      this.onPlay();
    }
  }

  onPlay() {
  }

  private loadScript() {
    let chatScript = document.createElement('script');
    chatScript.type = 'text/javascript';
    chatScript.async = true;
    chatScript.src = 'https://unpkg.com/@intheroomglobal/embed/dist/embed.min.js';
    document.getElementById('convo_' + this.task.id).appendChild(chatScript);
    console.log(document.getElementById('convo_' + this.task.id));
    // document.body.appendChild(chatScript);
  }

  private loadIframe() {
    this.simSrc = this.sanitizer.bypassSecurityTrustHtml('<body style=\'margin: 0\'>\n' +
      '            <convo data-aspect-ratio="1:1">\n' +
      '        <link href="https://unpkg.com/@intheroomglobal/embed/dist/embed.min.css" rel="stylesheet" />\n' +
      '        <a href="' + this.url + '"><span>View experience</span></a>\n' +
      '        <script src="https://unpkg.com/@intheroomglobal/embed/dist/embed.min.js"></script>\n' +
      '            </convo>\n' +
      '            </body>');
    console.log(this.simSrc);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(i => i.unsubscribe());
  }
}
